import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

const PrinterEyeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M7.66699 16.4167C7.75033 16.8333 8.00033 17.1667 8.16699 17.5H5.50033C5.22418 17.5 5.00033 17.2761 5.00033 17V14.1667H2.16699C1.89085 14.1667 1.66699 13.9428 1.66699 13.6667V9.16667C1.66699 7.75 2.75033 6.66667 4.16699 6.66667H15.8337C17.2503 6.66667 18.3337 7.75 18.3337 9.16667V12.1667C17.167 11.3333 15.7503 10.8333 14.167 10.8333C13.0003 10.8333 11.8337 11.1667 10.8337 11.6667H6.66699V15.8333H7.33366L7.66699 16.4167Z"
        fill="white"
      />
      <path
        d="M5.00033 5.83333H15.0003V3.5C15.0003 2.94772 14.5526 2.5 14.0003 2.5H6.00033C5.44804 2.5 5.00033 2.94771 5.00033 3.5V5.83333Z"
        fill="white"
      />
      <path
        d="M14.5143 12.3945C12.6204 12.3945 11.003 13.5726 10.3477 15.2354C11.003 16.8983 12.6204 18.0764 14.5143 18.0764C16.4083 18.0764 18.0257 16.8983 18.681 15.2354C18.0257 13.5726 16.4083 12.3945 14.5143 12.3945ZM14.5143 17.1294C13.4689 17.1294 12.6204 16.2809 12.6204 15.2354C12.6204 14.19 13.4689 13.3415 14.5143 13.3415C15.5598 13.3415 16.4083 14.19 16.4083 15.2354C16.4083 16.2809 15.5598 17.1294 14.5143 17.1294ZM14.5143 14.0991C13.8855 14.0991 13.378 14.6067 13.378 15.2354C13.378 15.8642 13.8855 16.3718 14.5143 16.3718C15.1431 16.3718 15.6507 15.8642 15.6507 15.2354C15.6507 14.6067 15.1431 14.0991 14.5143 14.0991Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default PrinterEyeIcon;
